<template>
  <div class="CarViolationRecordList">
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    >
      <div slot="custom-operate">
        <slot name="default"> </slot>
      </div>
    </base-list-management>
    <!-- 违章记录详情 -->
    <!-- eslint-disable-next-line -->
    <violationDetail :source="detailSource" ref="violationDetailRef" />
    <!-- 违章记录处理 -->
    <dialogWrap
      v-model="violationShow"
      :title="violationTitle"
      :width="'824px'"
      :before-close="setBtnCancel"
    >
      <template>
        <el-form
          :inline="true"
          :model="source"
          ref="source_from"
          :rules="source_rules"
          label-width="130px"
        >
          <el-col :span="12">
            <el-form-item :label="'车牌号' + columnSeparator" prop="plateNo">
              <span>{{ source.plateNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'违章时间' + columnSeparator"
              prop="violationTime"
            >
              <span>{{ source.violationTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="相关客户" prop="customerId">
              <el-select
                v-model="source.customerId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="
                  (query) => {
                    remoteMethod(query)
                  }
                "
                :loading="loading.fuzzy"
                clearable
              >
                <el-option
                  v-for="item in optionsName"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id"
                >
                  <CustomerNameOptionItem :data="item" />
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'相关订单' + columnSeparator" prop="orderId">
              <el-input
                style="width: 210px"
                placeholder="请输入"
                v-number:integer="18"
                v-model="source.orderId"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="'违章内容' + columnSeparator" prop="content">
              <div class="content">{{ source.content }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="'违章地点' + columnSeparator" prop="place">
              <el-input
                v-model="source.place"
                v-deleteEmoji="true"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'违章扣分' + columnSeparator"
              prop="penaltyPoint"
            >
              <span>{{ source.penaltyPoint }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'处理状态' + columnSeparator"
              prop="handleState"
            >
              <el-select
                placeholder="请选择"
                v-model="source.handleState"
                clearable
                @change="handleStateChange"
              >
                <el-option
                  v-for="item in handleStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'违章罚款' + columnSeparator"
              prop="penaltyAmount"
            >
              <span>{{ source.penaltyAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'缴款状态' + columnSeparator"
              prop="paymentState"
            >
              <el-select
                placeholder="请选择"
                v-model="source.paymentState"
                clearable
              >
                <el-option
                  v-for="item in paymentStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 处理时间 -->
          <el-col :span="13" v-show="resolveTimeStatus">
            <el-form-item
              :label="'处理时间' + columnSeparator"
              prop="handleCompleteTime"
            >
              <el-date-picker
                v-model="source.handleCompleteTime"
                placeholder="选择日期时间处理时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="'备注' + columnSeparator"
              label-width="130px"
              prop="handleRemarks"
            >
              <el-input
                v-deleteEmoji="true"
                style="width: 210px"
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model="source.handleRemarks"
                maxlength="500"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="resolveTimeStatus">
            <el-form-item
              :label="'处理方式' + columnSeparator"
              label-width="130px"
              prop="dealViolationWay"
            >
              <el-select
                placeholder="请选择"
                v-model="source.dealViolationWay"
                clearable
              >
                <el-option
                  v-for="item in dealViolationWayList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <template slot="footer">
          <el-button @click="setBtnCancel" size="small">取消</el-button>
          <el-button type="primary" @click="handleBtn" size="small"
            >处理完成</el-button
          >
        </template>
      </template>
    </dialogWrap>
    <!-- 删除弹框 -->
    <dialogWrap v-model="centerDialogVisible" title="提示" :width="'560px'">
      <p>是否删除该违章记录</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button :loading="loading.del" type="primary" @click="deleteFun()"
          >删除</el-button
        >
      </span>
    </dialogWrap>
    <!-- 违章处理方式 -->
    <selectViolationWay
      :visible="dvWayVisible"
      :id="violationId"
      @dvWayUpdated="refreshDetail"
      @dvWayChange="dvWayVisible = false"
    />
  </div>
</template>

<script>
import config from './config'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { ViolationUpdate, ViolationsDelte } from '@/api/serviceAPi'
import selectOption from '@/store/dict/selectOptionDict'
import selectViolationWay from '@/pages/carsService/violation/components/selectViolationWay'
import moment from 'moment'
import violationDetailMixins from '@/pages/service/Violation/mixins/violationDetail'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { getViolationInfo } from '@/api/domain/carsService'

export default {
  mixins: [violationDetailMixins],
  components: { selectViolationWay, CustomerNameOptionItem },
  data() {
    const configData = config.call(this)
    return {
      configData,
      optionsName: [], // 客户模糊列表
      violationShow: false, // 违章处理弹框的显隐
      violationTitle: '违章处理',
      source: {
        handleRemarks: '',
        completeTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      source_rules: {
        plateNo: [
          { required: true, message: '车牌号不能为空', trigger: 'blur' },
        ],
        violationTime: [
          { required: true, message: '违章时间不能为空', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '违章内容不能为空', trigger: 'blur' },
        ],
        penaltyPoint: [
          { required: true, message: '违章扣分不能为空', trigger: 'blur' },
        ],
        handleState: [
          { required: true, message: '处理状态不能为空', trigger: 'blur' },
        ],
        penaltyAmount: [
          { required: true, message: '违章罚款不能为空', trigger: 'blur' },
        ],
        paymentState: [
          { required: true, message: '缴款状态不能为空', trigger: 'blur' },
        ],
      },
      // 删除弹窗
      centerDialogVisible: false,
      loading: {
        del: false,
        fuzzy: true,
      },
      dvWayVisible: false,
      violationId: 0,
    }
  },
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 相关订单类型
    // eslint-disable-next-line vue/no-unused-properties
    orderTypeList() {
      return this.dictParseList(selectOption.relatedOrderTypeList)
    },
    // 处理状态
    handleStateList() {
      return this.dictParseList(selectOption.processingstatusDict)
    },
    // 缴款状态
    paymentStateList() {
      return this.dictParseList(selectOption.paymentStateList)
    },
    // 处理时间是否显示
    resolveTimeStatus() {
      // 处理状态：1-已处理
      if (Number(this.source.handleState) === 1) return true
      return false
    },
    dealViolationWayList() {
      return this.dictParseList(selectOption.dealViolationWayList)
    },
  },
  mounted() {
    this.configData.tableData.columns.push(this.configData.operateColumn)
    this.setDefaultParams()
  },
  methods: {
    setDefaultParams() {
      // 车俩id带入默认值直接搜索违章记录
      const { id } = this.$route.query
      this.configData.formData.formProps.model.carId = id
    },
    // 触发搜索事件
    doSearch() {
      this.$nextTick(() => {
        this.$refs.baseListManagement.searchForm('form')
      })
    },
    /* 客户模糊搜索 */
    async remoteMethod(query) {
      this.loading.fuzzy = true
      searchByCustomerNameSensitive({
        customerName: query ? query.trim() : '',
        customerState: 1,
        mixedType: 'YES',
      })
        .then(({ code, data = [] }) => {
          if (code === 1) {
            this.optionsName = data
          }
        })
        .finally(() => {
          this.loading.fuzzy = false
        })
    },
    deleteFun() {
      this.getDel(this.violationId)
    },
    // 删除请求
    async getDel(res) {
      try {
        this.loading.del = true
        const data = await ViolationsDelte({
          id: res,
        })
        this.loading.del = false
        if (data.code === 1) {
          this.$message.success('删除成功')
          this.centerDialogVisible = false
          this.doSearch()
        }
      } catch (error) {
        this.loading.del = false
      }
    },
    /* 打开删除 */
    // eslint-disable-next-line vue/no-unused-properties
    openDel(res) {
      this.centerDialogVisible = true
      this.violationId = res.id
    },
    // 打开违章处理方式
    // eslint-disable-next-line vue/no-unused-properties
    openWay(row) {
      this.violationId = row.id
      this.dvWayVisible = true
    },
    refreshDetail() {
      this.doSearch()
    },
    // 违章处理取消按钮
    setBtnCancel() {
      this.source = {
        handleRemarks: '',
        completeTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      }
      this.$refs.source_from.resetFields()
      this.violationShow = false
    },
    /* 违章处理接口 */
    async handleBtn() {
      this.$refs.source_from.validate((volid) => {
        if (volid) {
          this.Processing_complete = volid
        }
      })
      if (!this.Processing_complete) {
        return
      }
      const res = await ViolationUpdate(this.source)
      if (res.code === 1) {
        this.$message.success('处理成功')
        this.violationShow = false
        this.doSearch()
      }
    },
    /* 违章处理 */
    // eslint-disable-next-line vue/no-unused-properties
    violation(row) {
      this.violationShow = !this.violationShow
      if (this.violationShow) {
        this.remoteMethod()
      }
      const { id } = row
      getViolationInfo({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.source = { ...this.source, ...data }
        }
      })
    },
    // 处理状态change
    handleStateChange() {
      this.$set(this.source, 'handleCompleteTime', '')
      this.$set(this.source, 'dealViolationWay', '')
    },
  },
}
</script>

<style scoped>
.content {
  width: 610px;
}
</style>
